/**
 * A subscription item collection represents a subscription item that is associated with a recurring quotation item.
 */
export interface SubscriptionItem {
  readonly id: number;
  readonly quotationItemVersionId: number;
  readonly createDate: number;
  readonly status: SubscriptionItemStatusApi;
  readonly projectId: number;
}

/**
 * The below types will be replaced by thrift types in T288943
 */
export interface SubscriptionItemApi {
  readonly id: number;
  readonly quotation_item_version_id: number;
  readonly create_date: number;
  readonly status: SubscriptionItemStatusApi;
  readonly project_id: number;
}

export enum SubscriptionItemStatusApi {
  ACTIVE = 'active',
  PAUSED = 'paused',
  CANCELLED = 'cancelled',
}

export interface SubscriptionItemUpdateRequestApi {
  readonly status?: SubscriptionItemStatusApi;
}
export interface SubscriptionItemGetReponseApi {
  readonly subscription_items?: readonly SubscriptionItemApi[];
}
